var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.4173 41.7917H28.3339C27.1723 41.7917 26.2089 40.8283 26.2089 39.6667C26.2089 38.505 27.1723 37.5417 28.3339 37.5417H35.4173C42.8406 37.5417 48.8756 31.5067 48.8756 24.0833C48.8756 16.66 42.8406 10.625 35.4173 10.625H21.2506C13.8273 10.625 7.79226 16.66 7.79226 24.0833C7.79226 27.2 8.89724 30.2316 10.8806 32.64C11.6172 33.5466 11.5039 34.8783 10.5972 35.6433C9.69058 36.38 8.35892 36.2667 7.59392 35.36C4.95892 32.1867 3.51392 28.1917 3.51392 24.0833C3.51392 14.3083 11.4472 6.375 21.2222 6.375H35.3889C45.1639 6.375 53.0972 14.3083 53.0972 24.0833C53.0972 33.8583 45.1923 41.7917 35.4173 41.7917Z",
    fill: "#5F5F5F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.75 61.6249H32.5833C22.8083 61.6249 14.875 53.6916 14.875 43.9166C14.875 34.1416 22.8083 26.2083 32.5833 26.2083H39.6667C40.8283 26.2083 41.7917 27.1716 41.7917 28.3333C41.7917 29.4949 40.8283 30.4583 39.6667 30.4583H32.5833C25.16 30.4583 19.125 36.4933 19.125 43.9166C19.125 51.3399 25.16 57.3749 32.5833 57.3749H46.75C54.1733 57.3749 60.2083 51.3399 60.2083 43.9166C60.2083 40.7999 59.1033 37.7683 57.12 35.36C56.3833 34.4533 56.4967 33.1216 57.4033 32.3566C58.31 31.5916 59.6417 31.7332 60.4067 32.6399C63.0417 35.8132 64.4867 39.8083 64.4867 43.9166C64.4583 53.6916 56.525 61.6249 46.75 61.6249Z",
    fill: "#5F5F5F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.04a2b1be1f09ec134b834a51b165494a.svg";
export { ForwardRef as ReactComponent };